import React, { useState, useMemo } from "react";
import styled from "styled-components/macro";
import Search from "@material-ui/icons/Search";
import { PrintCard } from "./print_card";
import { theme } from "./theme";

const PrinterList = ({ printers, jobs, onChoosePrint, setPrinter }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredPrinters = useMemo(() => {
    const list = Object.values(printers).sort(function (a, b) {
      const aName = (a.room_name || a.title || "").toLowerCase();
      const bName = (b.room_name || b.title || "").toLowerCase();
      if (aName < bName) {
        return -1;
      }
      if (aName > bName) {
        return 1;
      }
      return 0;
    });

    if (!searchQuery.trim()) {
      return list;
    }

    const query = searchQuery.toLowerCase().trim();
    return list.filter((printer) =>
      (printer.room_name || printer.title || "").toLowerCase().includes(query)
    );
  }, [printers, searchQuery]);

  return (
    <Wrapper>
      <SearchContainer>
        <SearchBox>
          <Search style={{ fontSize: 15, color: "#B4AEC6" }} />
          <SearchInput
            type="text"
            placeholder="Search printers…"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {searchQuery && (
            <ClearButton onClick={() => setSearchQuery("")}>×</ClearButton>
          )}
        </SearchBox>
      </SearchContainer>
      <PrinterListContainer>
        {filteredPrinters.length > 0 ? (
          filteredPrinters.map((item, index) => (
            <PrintCard
              key={item.id}
              printer={item}
              jobs={jobs}
              delay={index * 35}
              onClick={() => {
                if (onChoosePrint) {
                  return onChoosePrint(item);
                }
                setPrinter && setPrinter(item);
              }}
            />
          ))
        ) : (
          <NoResults>No printers found matching "{searchQuery}"</NoResults>
        )}
      </PrinterListContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: ${theme.fontFamily};
`;

const SearchContainer = styled.div`
  position: relative;
  padding: 20px 24px;
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  height: 42px;
  padding: 0 14px;
  min-width: 300px;
  max-width: 420px;
  font-family: ${theme.fontFamily};
  background: #ffffff;
  border: 1px solid #ebe6f6;
  border-radius: 12px;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #d7c9f5;
  }

  &:focus-within {
    border-color: #d7c9f5;
  }
`;

const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: ${theme.fontFamily};
  font-size: 13.5px;
  color: #333333;

  &::placeholder {
    color: #b4aec6;
  }
`;

const ClearButton = styled.button`
  flex-shrink: 0;
  background: none;
  border: none;
  font-size: 15px;
  line-height: 1;
  color: #a09ab2;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: ${theme.textMuted};
  }
`;

const PrinterListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
  padding: 4px 24px 40px;
`;

const NoResults = styled.div`
  grid-column: 1 / -1;
  padding: 40px 24px;
  text-align: center;
  color: ${theme.textMuted};
  font-size: 14px;
`;

export { PrinterList };
